import(/* webpackMode: "eager" */ "D:\\Verasoft\\KORVUE-XL\\rxl\\src\\app\\not-found.tsx");
